// extracted by mini-css-extract-plugin
export var link = "privacy-module--link--dlJ--";
export var privacy = "privacy-module--privacy--qmczt";